import {
    FORM_SUBMIT,
    FORM_FIELDS_VALUE,
    FORM_FIELD_REMOVE
} from './types'

// Notify the form to dispatch a default submit action.
export function formSubmit() {
    return {
        type: FORM_SUBMIT
    }
}

// Merge the object payload in the form object.
// payload : object with field names as key and values.
// meta : object with metadata for each field name.
export function formFieldsValue(data, meta) {
    return {
        type: FORM_FIELDS_VALUE,
        payload: {
            data,
            meta
        }
    }
}

// Removes one or more fields by name, all if no arguments.
// name : single field name or array of names.
//        If empty, removes all the fields.
export function formFieldRemove(names) {
    return {
        type: FORM_FIELD_REMOVE,
        payload: names
    }
}
